import { DefaultState } from '@src/redux/types'

import {
  ACCOMMODATION,
  ACCOMMODATION_CHANGE_STATUS,
  ACCOMMODATION_CREATE,
  ACCOMMODATION_DELETE,
  ACCOMMODATION_LIST,
  ACCOMMODATION_STUDENT_INFO,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ACCOMMODATION]: DefaultState<`${typeof API.ACCOMMODATION}{id}`, 'get'>
  [ACCOMMODATION_CREATE]: DefaultState<`${typeof API.ACCOMMODATION}`, 'post'>
  [ACCOMMODATION_DELETE]: DefaultState<`${typeof API.ACCOMMODATION}{id}`, 'delete'>
  [ACCOMMODATION_STUDENT_INFO]: DefaultState<`${typeof API.ACCOMMODATION_STUDENT_INFO}`, 'get'>
  [ACCOMMODATION_LIST]: DefaultState<`${typeof API.ACCOMMODATION}`, 'get'>
  [ACCOMMODATION_CHANGE_STATUS]: DefaultState<`${typeof API.ACCOMMODATION_CHANGE_STATUS}`, 'put'>
} = () => ({
  [ACCOMMODATION]: defaultState(),
  [ACCOMMODATION_CREATE]: defaultState(),
  [ACCOMMODATION_DELETE]: defaultState(),
  [ACCOMMODATION_STUDENT_INFO]: defaultState(),
  [ACCOMMODATION_LIST]: defaultState(),
  [ACCOMMODATION_CHANGE_STATUS]: defaultState(),
})
